import basicController from "servicestack/basic.controller.properties";
import AutoQueryConfig from "servicestack/auto-query/auto-query.config";

export default class AutoQueryHeaderController {
  constructor() {
    basicController(this);
    let $ctrl = this;
    $ctrl.config = AutoQueryConfig;
    $ctrl.hideExport = AutoQueryConfig.hideExport;
  }
}
